import { render, staticRenderFns } from "./MobileDetailsAdvantages.vue?vue&type=template&id=5f8fb8ce"
import script from "./MobileDetailsAdvantages.vue?vue&type=script&lang=js"
export * from "./MobileDetailsAdvantages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports